/**
 * Retrieves the client ID from the universal login context.
 * This can be called early (before SDK instances are created).
 */
export function getClientId(): string | undefined {
  return window.universal_login_context?.client?.id;
}

/**
 * Set of client IDs that should use Atlas screen variants.
 * Add your actual Atlas client IDs here.
 */
export const ATLAS_CLIENT_IDS = new Set<string>([
  // Example: "atlas_prod_client_id",
  // Add actual client IDs from Auth0
  "atlas_mock_client_id",
  "vq0PE6i9cVUlsMZqldQ6Pcr7HqpqDSvr",
  "cy2VUFu87kn42c5HAjNY1wOMpRpLwIeD",
]);

/**
 * Checks if the current request is from an Atlas client.
 */
export function isAtlasClient(): boolean {
  const clientId = getClientId();
  return clientId ? ATLAS_CLIENT_IDS.has(clientId) : false;
}
